import { useLayoutEffect, useRef } from 'react'

const BASE_PX = 16
const COMPACT_PX = 14
const LINE_HEIGHT = 1.25

/**
 * Размер текста вариантов: вариант, не влезший в строку при 16px, идёт 14px, чтобы длинные
 * ответы заняли меньше места и остались на экране. Короткие варианты остаются крупными.
 */
export const useFitOptions = (key: string) => {
  const ref = useRef<HTMLDivElement>(null)

  useLayoutEffect(() => {
    const list = ref.current
    if (!list) return
    const fit = () => {
      list.querySelectorAll<HTMLElement>('[data-option-text]').forEach((text) => {
        text.style.fontSize = ''
        if (text.offsetHeight > BASE_PX * LINE_HEIGHT + 1) text.style.fontSize = `${COMPACT_PX}px`
      })
    }
    fit()
    if (typeof ResizeObserver === 'undefined') return
    let width = list.clientWidth
    const observer = new ResizeObserver(() => {
      if (list.clientWidth !== width) {
        width = list.clientWidth
        fit()
      }
    })
    observer.observe(list)
    return () => observer.disconnect()
  }, [key])

  return ref
}
